import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-shoppen',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconShoppen {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M30.18 9h-5.13l-.02 3.87c.3.27.5.67.5 1.11 0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5c0-.44.2-.84.5-1.11V6.92a6.919 6.919 0 0 0-2-4.84c2.25.37 4 2 4 3.94v.62c0 .55.45 1 1 1s1-.45 1-1v-.62C27.03 2.7 23.89 0 20.07 0c-.7 0-1.38.09-2.04.27V.25s-.04.01-.05.02C17.37.1 16.75 0 16.1 0c-3.9 0-7.08 3.11-7.08 6.93L9 9H5.89c-1.05-.02-1.92.79-2 1.84L2.16 33.86c-.09 1.16.83 2.15 1.99 2.15h27.68c1.16 0 2.08-.99 1.99-2.14l-1.66-23a2.005 2.005 0 0 0-1.99-1.86Zm-19.69 4.99c0-.44.2-.84.5-1.11l.03-5.95c0-2.21 1.51-4.06 3.58-4.68-.96 1.04-1.57 2.35-1.57 3.78v.62c0 .55.45 1 1 1s1-.45 1-1v-.62c0-1.58 1.21-3.01 2.95-3.66 1.8.72 3.05 2.47 3.05 4.56l-.02 2.06h-8l-.02 3.89c.3.27.5.67.5 1.11 0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5M19 21.01c.55 0 1 .45 1 1s-.45 1-1 1h-3.6c-.05.32-.08.66-.08 1s.03.68.08 1H19c.55 0 1 .45 1 1s-.45 1-1 1h-2.9c.69 1.21 1.78 2 3.02 2 .79 0 1.55-.32 2.2-.93a.996.996 0 0 1 1.41.04c.38.4.36 1.04-.04 1.41-1.02.96-2.26 1.47-3.56 1.47-2.31 0-4.3-1.64-5.23-4h-.89c-.55 0-1-.45-1-1s.45-1 1-1h.38c-.04-.33-.07-.66-.07-1s.03-.67.07-1h-.38c-.55 0-1-.45-1-1s.45-1 1-1h.89c.93-2.36 2.93-4 5.23-4 1.31 0 2.54.51 3.57 1.47a.996.996 0 1 1-1.37 1.45c-.65-.61-1.41-.93-2.2-.93-1.24 0-2.33.79-3.02 2h2.9Z"/>
</svg>

    );
  }
}
